var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYearArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_7104_30955)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5771L11.002 10.0198L7 6.4625L7.80039 5.03958L13.4031 10.0198L7.80039 15L7 13.5771Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7104_30955",
    x1: -3.89738e-8,
    y1: 10.1299,
    x2: 21.519,
    y2: 10.1299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearArrowRight);
export default __webpack_public_path__ + "static/media/year_arrow_right.6855b11358d904c75a05cc397f14428f.svg";
export { ForwardRef as ReactComponent };